import { Grid } from '@material-ui/core';
import { LinkArea } from './LinkArea';
import type { TCrestedGuest } from '../../../types/CloudStorageModal';

type TProps = {
  createdGuest: TCrestedGuest;
};

export const CreatedGuestField = (props: TProps) => {
  const { createdGuest } = props;

  const expirationAt =
    createdGuest.expiration_at === 'None' ? 'なし' : createdGuest.expiration_at;
  const uploadable = createdGuest.uploadable
    ? 'アップロード可能'
    : 'アップロード不可';

  return (
    <>
      <Grid xs={6}>
        <p
          style={{
            marginTop: 32,
            paddingRight: 10,
            overflowWrap: 'break-word'
          }}
        >
          {createdGuest.name}
        </p>
        <p style={{ paddingRight: 10, overflowWrap: 'break-word' }}>
          {createdGuest.email}
        </p>
      </Grid>
      <Grid xs={4}>
        <p style={{ marginTop: 32 }}>{`共有期限 ${expirationAt}`}</p>
        <p>{uploadable}</p>
      </Grid>

      {/* リンクURLエリア（コピーとメール送信） */}
      <LinkArea
        id={createdGuest.id}
        name={createdGuest.name}
        email={createdGuest.email}
        url={createdGuest.url}
      />
    </>
  );
};
